import { render, staticRenderFns } from "./AppInfo.vue?vue&type=template&id=52e002a0&scoped=true"
import script from "./AppInfo.vue?vue&type=script&lang=ts"
export * from "./AppInfo.vue?vue&type=script&lang=ts"
import style0 from "./AppInfo.vue?vue&type=style&index=0&id=52e002a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e002a0",
  null
  
)

export default component.exports